(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  /* Info card popup + remote-content fetcher */
  (function () {
    if (window.__infoCardModalBound) return;
    window.__infoCardModalBound = true;

    let lastTrigger = null;
    const remoteCache = new Map(); // key: url|selector -> Promise<string>

    function cacheKey(url, selector) {
      return (url || '') + '||' + (selector || '');
    }

    function fetchRemote(url, selector) {
      const key = cacheKey(url, selector);
      if (remoteCache.has(key)) return remoteCache.get(key);

      const p = fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          // Parse the response and pull out the target node(s).
          const doc = new DOMParser().parseFromString(html, 'text/html');
          let node = null;
          const sel = (selector || '').trim();
          if (sel) {
            node = doc.querySelector(sel);
          }
          if (!node) {
            // Fall back to <main>, then <body>
            node = doc.querySelector('main') || doc.body;
          }
          // Strip scripts for safety
          node.querySelectorAll('script, style[data-skip], noscript').forEach(function (el) {
            el.remove();
          });
          return node.innerHTML;
        });

      remoteCache.set(key, p);
      return p;
    }

    function renderRemote(container, url, selector) {
      // Avoid double-fetch
      if (container.dataset.infoCardLoaded === 'true' || container.dataset.infoCardLoading === 'true') return;
      container.dataset.infoCardLoading = 'true';

      fetchRemote(url, selector)
        .then(function (html) {
          container.innerHTML = html;
          container.dataset.infoCardLoaded = 'true';
          container.dataset.infoCardLoading = 'false';
        })
        .catch(function (err) {
          container.dataset.infoCardLoading = 'false';
          container.innerHTML =
            '<div class="product__info-card-error">' +
            'Content could not be loaded. ' +
            '<a href="' +
            encodeURI(url) +
            '" target="_blank" rel="noopener">Open in a new tab</a>.' +
            '</div>';
          // eslint-disable-next-line no-console
          console.warn('[info-card] fetch failed:', err);
        });
    }

    function loadInlineRemotes() {
      document.querySelectorAll('[data-info-card-remote]:not([data-info-card-loaded="true"])').forEach(function (el) {
        const url = el.getAttribute('data-info-card-url');
        const selector = el.getAttribute('data-info-card-selector');
        if (url) renderRemote(el, url, selector);
      });
    }

    function openModal(id) {
      const modal = document.getElementById(id);
      if (!modal) return;
      modal.setAttribute('open', '');
      document.body.classList.add('info-card-modal-open');

      // Lazy-load remote content on first open
      const url = modal.getAttribute('data-info-card-url');
      if (url) {
        const contentEl = modal.querySelector('[data-info-card-content]');
        if (contentEl && contentEl.dataset.infoCardLoaded !== 'true') {
          renderRemote(contentEl, url, modal.getAttribute('data-info-card-selector'));
        }
      }

      const closeBtn = modal.querySelector('[data-info-card-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.removeAttribute('open');
      document.body.classList.remove('info-card-modal-open');
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    document.addEventListener('click', function (e) {
      const opener = e.target.closest('[data-info-card-open]');
      if (opener) {
        lastTrigger = opener;
        openModal(opener.getAttribute('data-info-card-open'));
        return;
      }

      const closer = e.target.closest('[data-info-card-close]');
      if (closer) {
        closeModal(closer.closest('[data-info-card-modal]'));
        return;
      }

      // Click on backdrop
      const modal = e.target.closest('[data-info-card-modal]');
      if (modal && e.target === modal) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const open = document.querySelector('[data-info-card-modal][open]');
        if (open) closeModal(open);
      }
    });

    // Inline remote blocks: fetch on page ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadInlineRemotes);
    } else {
      loadInlineRemotes();
    }

    document.addEventListener('shopify:section:load', loadInlineRemotes);
    document.addEventListener('shopify:block:select', loadInlineRemotes);
  })();

  } catch(e) { console.error(e); }
})();
})();
